module.exports = __webpack_public_path__ + "static/media/headerImage2.e5a86059.png";